import { Directive } from '@angular/core';
@Directive({
  selector: 'ly-before-input, ly-after-input'
})
export class LyInputContents {

}
